import { render } from "./DepartementView.vue?vue&type=template&id=90ef5d18"
import script from "./DepartementView.vue?vue&type=script&lang=js"
export * from "./DepartementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__